import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/components/Home'
import Contacto from '@/components/Contacto'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: Home
    },
    {
      path: '/contacto',
      component: Contacto
    }
  ],
  linkActiveClass: 'active',
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js